export default __webpack_public_path__ + "static/media/t30.e20b0ed2.jpg";